import React, { useEffect } from "react";
import { useEnforcement } from "@common/components/hooks/useEnforcement";
import EnforcementForm from "@common/components/shared/Enforcement/EnforcementForm";
import { FormProvider } from "react-hook-form";
import { ENFORCEMENT_VISIT_TYPE } from "../details/EventDetailsForm.js";
import useComplianceView from "../../../hooks/useComplianceView.js";
import { parseEnforcementVisitResponse } from "@common/components/helpers/compliance.js";
import useIncidentContainer from "../../../hooks/useIncidentContainer.js";
import ComplianceHeader from "../ComplianceHeader.js";
import { Loader } from "semantic-ui-react";

const EnforcementVisitContainer = () => {
  const {
    methods,
    methods: { reset },
  } = useEnforcement();
  const {
    formLoading,
    incident: {
      record,
      record: {
        id,
        enforcementVisit: { officer },
        incidentType: { name },
      },
    },
  } = useComplianceView();
  const { onRowUpdate } = useIncidentContainer();

  useEffect(() => {
    if (name !== ENFORCEMENT_VISIT_TYPE) {
      return;
    }

    reset(parseEnforcementVisitResponse(record));

    methods.setValue("officer", officer);
  }, [record]);

  if (formLoading) {
    return <Loader active />;
  }

  return (
    <FormProvider {...methods}>
      <ComplianceHeader title="Enforcement Visit" loadRecord={onRowUpdate} />
      <EnforcementForm key={id} />
    </FormProvider>
  );
};

export default EnforcementVisitContainer;
